
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { useRouter } from 'next/router';
import { GetStaticProps, NextPage } from 'next';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import Stack from '@mui/material/Stack';
import FiltersPanel, { Filter, FilterGroup } from 'pages/wiki/filters';
import ResponsiveContainer from 'components/atomic/organisms/responsive-container';
import RightPanel from 'pages/wiki/right-panel';
import HeaderBar from 'components/atomic/organisms/header';
import ToolCard from 'pages/wiki/item-card/tool';
import useFilters from 'pages/wiki/use-filters';
import Footer from 'components/atomic/organisms/footer';
import ItemList from 'pages/wiki/item-list';
import Hero from 'pages/wiki/hero';
import Routes, { toAbsoluteUrl } from 'utils/routes';
import { ToolOverview } from 'types/wiki';
import devvSdk from 'utils/devv-sdk';
const SEO = () => {
    const router = useRouter();
    const keywords = [
        'tool di programmazione',
        'strumenti di programmazione',
        'strumenti di programmazione più utilizzati',
        'strumenti di programmazione più utili',
        'framework',
        'librerie',
        'ide',
        'sistemi operativi',
    ];
    return (<>
            <NextSeo title="Strumenti per programmatori" titleTemplate={'%s | Devv'} description="Esplora i Tool, Framework, Librerie, IDE e Sistemi Operativi piu utili e usati al mondo. Scopri le loro caratteristiche e come utilizzarli al meglio. Migliora le tue competenze e diventa un programmatore migliore!" canonical={`${toAbsoluteUrl(router.asPath)}`} additionalMetaTags={[
            {
                property: 'keywords',
                content: keywords.join(', '),
            },
        ]} openGraph={{
            url: `${toAbsoluteUrl(router.asPath)}`,
            images: [
                {
                    url: `${toAbsoluteUrl(`/assets/og/wiki-tools.png`)}`,
                    secureUrl: `${toAbsoluteUrl(`/assets/og/wiki-tools.png`)}`,
                    type: 'image/png',
                    width: 1200,
                    height: 630,
                },
            ],
        }}/>
            <BreadcrumbJsonLd itemListElements={[
            {
                position: 1,
                name: 'Wiki',
                item: `${toAbsoluteUrl(Routes.Wiki)}`,
            },
            {
                position: 2,
                name: 'Strumenti per programmatori',
                item: `${toAbsoluteUrl(Routes.WikiTools)}`,
            },
        ]}/>
        </>);
};
interface ToolsPageProps {
    tools: ToolOverview[];
    filters: Filter[];
}
const ToolsPage: NextPage<ToolsPageProps> = (props) => {
    const { addFilter, removeFilter, clearFilters, activeFilters, setSearch, filteredItems } = useFilters(props.tools);
    return (<>
            <SEO />

            <HeaderBar />

            <Hero title="Strumenti per programmatori" description="Esplora i Tool, Framework, Librerie, IDE e Sistemi Operativi piu utili e usati al mondo. Scopri le loro caratteristiche e come utilizzarli al meglio. Migliora le tue competenze e diventa un programmatore migliore!" searchPlaceholder="Cerca un Tool, Libreria, IDE ..." onSearch={(s) => setSearch(s)} color="#39916d"/>

            <ResponsiveContainer maxWidth={'xl'}>
                <Stack direction={'row'}>
                    <FiltersPanel>
                        {props.filters.map((filter, index) => (<FilterGroup key={index} title={filter.title} items={filter.items} activeFilters={activeFilters} onClear={clearFilters} onAdd={addFilter} onRemove={removeFilter}/>))}
                    </FiltersPanel>

                    <ItemList items={filteredItems} count={filteredItems.length} activeFilters={activeFilters} onRemoveFilter={removeFilter} itemColumns={{ xs: 12, sm: 4, md: 3 }} renderItem={(item) => <ToolCard item={item}/>}/>

                    <RightPanel />
                </Stack>
            </ResponsiveContainer>

            <Footer />
        </>);
};
const getStaticProps: GetStaticProps = async () => {
    const { data: toolsOverview } = await devvSdk.getToolsOverview();
    const { data: rolesOverview } = await devvSdk.getRolesOverview();
    const { data: languagesOverview } = await devvSdk.getLanguagesOverview();
    const filters = [
        {
            title: 'Filtra per ruolo',
            items: rolesOverview
                .map((el) => ({
                slug: el.slug,
                title: el.title,
                count: el.categories.filter((el1) => toolsOverview.find((t) => t.slug === el1)).length,
                tags: el.categories.filter((el1) => toolsOverview.find((t) => t.slug === el1)),
            }))
                .filter((el) => el.count > 0)
                .sort((a, b) => b.count - a.count),
        },
        {
            title: 'Filtra per linguaggio',
            items: languagesOverview
                .map((el) => ({
                slug: el.slug,
                title: el.title,
                count: toolsOverview.filter((el1) => el1.categories.includes(el.slug)).length,
                tags: toolsOverview.filter((el1) => el1.categories.includes(el.slug)).map((el1) => el1.slug),
            }))
                .filter((el) => el.count > 0)
                .sort((a, b) => b.count - a.count),
        },
    ];
    return {
        props: {
            tools: toolsOverview,
            filters,
        },
    };
};
export default ToolsPage;

    async function __Next_Translate__getStaticProps__18916ceb2f8__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/wiki/tools/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb2f8__ as getStaticProps }
  